import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { ManipulationsToolbarStore } from 'src/app/store/manipulations-toolbar-store';
import { RecipientsDisplayComponent } from "../recipients-display/recipients-display.component";
import { toSignal } from '@angular/core/rxjs-interop';
import { EQuestionnaireStatus } from 'src/app/models/questionnaireGrid.model';

@Component({
    selector: 'que-status-filter',
    templateUrl: './status-filter.component.html',
    styleUrls: ['./status-filter.component.scss'],
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: StatusFilterComponent, multi: true }],
    imports: [
        CommonModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatOptionModule,
        MatAutocompleteModule,
        ReactiveFormsModule,
        FormsModule,
        MatCheckboxModule,
        TranslateDirective, TranslatePipe,
        RecipientsDisplayComponent
    ]
})
export class StatusFilterComponent implements ControlValueAccessor, OnInit {
  enumQStatus = EQuestionnaireStatus;
  #manipulationsToolbarStore = inject(ManipulationsToolbarStore);
  selectedFilter$ = toSignal(this.#manipulationsToolbarStore.selectedFilter$);
  statusList = [
    {
      status: EQuestionnaireStatus.Edit,
      choosed: false
    },
    {
      status: EQuestionnaireStatus.Distributed,
      choosed: false
    },
    {
      status: EQuestionnaireStatus.Respond,
      choosed: false
    },
  ];

  ngOnInit() {
    this.statusList.map(x => this.selectedFilter$()?.status?.includes(x.status)? x.choosed = true : false)
  }

  
  valueControl = new FormControl<EQuestionnaireStatus[] | null>(null);
  callBackFunction: Function = () => { };

  writeValue(obj: any): void {
    this.valueControl.setValue(obj);
  }

  registerOnChange(fn: any): void {
    this.callBackFunction = fn;
  }

  registerOnTouched(fn: any): void {
    // throw new Error('Method not implemented.');
  }

  selectStatus(item: any) {
    item.choosed = !item.choosed;
    const itemsSelected = this.statusList.filter(x => x.choosed == true).map(x => { return x.status });
    this.valueControl.setValue(itemsSelected);
    if (this.callBackFunction) {
      this.callBackFunction(this.valueControl.value);
    }
  }
}
